import PropTypes from 'prop-types';

const EchoIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.09 24.464c0 3.298-2.707 5.97-6.045 5.97-3.34 0-6.046-2.672-6.046-5.97 0-3.297 2.707-5.97 6.046-5.97 3.338 0 6.044 2.673 6.044 5.97M7.007 7.64a2.152 2.152 0 0 1 3.062 0c.864.853.864 2.17 0 3.023-7.694 7.599-7.694 20.004-.078 27.524.864.853.864 2.171 0 3.024-.393.388-.942.62-1.492.62s-1.1-.232-1.492-.62c-9.343-9.304-9.343-24.345 0-33.571zm5.575 5.504a2.152 2.152 0 0 1 3.061 0 2.159 2.159 0 0 1-.078 3.024 11.642 11.642 0 0 0 0 16.592c.864.853.864 2.171 0 3.024-.393.388-.942.62-1.492.62s-1.099-.232-1.491-.62c-6.282-6.28-6.282-16.437 0-22.64zM37.94 7.717a2.152 2.152 0 0 1 3.062 0c9.342 9.227 9.342 24.268-.079 33.572-.392.388-.942.62-1.492.62s-1.099-.232-1.491-.62c-.864-.853-.864-2.171 0-3.024 7.694-7.598 7.694-20.003 0-27.524-.864-.853-.864-2.17 0-3.024zm-5.496 5.427a2.152 2.152 0 0 1 3.062 0 15.886 15.886 0 0 1-.078 22.64c-.393.388-.942.62-1.492.62s-1.1-.232-1.492-.62c-.864-.853-.864-2.17 0-3.024a11.642 11.642 0 0 0 0-16.592c-.864-.853-.864-2.17 0-3.024z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

EchoIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

EchoIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default EchoIcon;
